import { useMemo } from 'react';
import { useWorkspaceDocs } from './use-workspace-docs';
import type { WorkspaceDoc } from '../entity-types';

/** Per-doc escape hatch — reads full list and finds by id. */
export function useWorkspaceDoc(id: string | null | undefined): WorkspaceDoc | undefined {
  const docs = useWorkspaceDocs();
  return useMemo(() => {
    if (!id) return undefined;
    return docs.find((d) => d.id === id);
  }, [docs, id]);
}
